import { ModalId } from '../../../../../enums/modalId'

export const getBlockCreateDepositInvoiceActionModalId = (scopeId?: string): string =>
  scopeId ? `${scopeId}-${ModalId.BlockCreateDepositInvoiceActionModal}` : ModalId.BlockCreateDepositInvoiceActionModal
